import axios from "axios";
import Errores from "@/utils/Errores";

export const ProcesaJsonParametros = {
  obtenerInformacion: async (componente, tokenBearer) => {
    try {
      const response = await axios.get(JSONPARAMETROS, {
        headers: {
          Authorization: `Bearer ${tokenBearer}`
        }
      });
      if (response.data) {
        const parametros = response.data.reduce((acc, elemento) => {
          acc[elemento.llave] = elemento;
          return acc;
        }, {});
        if (parametros.anioPostulacion) {
          return {
            C_periodoListaEsperaResultado:
              parametros.C_periodoListaEsperaResultado.valor,
            C_periodoRegularizacion: parametros.C_periodoRegularizacion.valor,
            C_fechaLimiteModificacionPostulacion:
              parametros.C_fechaLimiteModificacionPostulacion.valor,
            C_fechaPublicacionResultadoComplementario:
              parametros.C_fechaPublicacionResultadoComplementario.valor,
            C_anioEscolar: parametros.C_anioEscolar.valor,
            C_mostrarMatriculaAsegurada:
              parametros.C_mostrarMatriculaAsegurada.valor,
            C_periodoComplementario: parametros.C_periodoComplementario.valor,
            C_terminoEtapa1Resultados:
              parametros.C_terminoEtapa1Resultados.valor,
            C_fechaFinPostulacion: parametros.C_fechaFinPostulacion.valor,
            C_fechaResultados: parametros.C_fechaResultados.valor,
            C_periodoMatricula: parametros.C_periodoMatricula.valor
          };
        } else {
          console.error("Respuesta de JSON incorrecta");
          return null;
        }
      }
    } catch (error) {
      Errores.switchErrors(error, componente);
      console.error(
        "Error al cargar parámetros iniciales desde JSON:",
        error.response || error.message || error
      );
      return null;
    }
  }
};

export default ProcesaJsonParametros;



// WEBPACK FOOTER //
// ./src/service/ProcesaJsonParametros.js